import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { queryKeys } from '../utils/constants/queryKeys';
import { IWebsiteBlockFloorEmptyFlatCount } from '../utils/models/IWebsiteBlockFloorEmptyFlatCount';
import { IWebsiteBlockFloorStatistic } from '../utils/models/IWebsiteBlockFloorStatistic';
import { IWebsiteFlatStatistics } from '../utils/models/IWebsiteFlatStatistics';

export function useWebsiteBlockFloorStatistic(blockId: number) {
  return useQuery<IWebsiteBlockFloorStatistic>(
    [queryKeys.WEBSITE_BLOCK_FLOOR_STATISTIC, blockId],
    async () => {
      const res = await $api.get(`/v2/website/block-floor-statistic/${blockId}`);

      return res?.data?.data;
    },
    {
      enabled: !!blockId,
      onError: baseErrorHandler,
      refetchOnWindowFocus: false
    }
  );
}

export function useWebsiteBlockFloorEmptyFlatCount(blockId: number) {
  return useQuery<IWebsiteBlockFloorEmptyFlatCount[]>(
    [queryKeys.WEBSITE_BLOCK_ID_FLOOR_EMPTY_FLAT_COUNT, blockId],
    async () => {
      const res = await $api.get(`/v2/website/block/${blockId}/floor/empty-flat-count`);

      return res?.data?.data;
    },
    {
      enabled: !!blockId,
      onError: baseErrorHandler,
      refetchOnWindowFocus: false
    }
  );
}

export function useWebsiteBlockFlatStatistic(blockId: number, floor: number) {
  return useQuery<IWebsiteFlatStatistics>(
    [queryKeys.WEBSITE_BLOCK_FLAT_DATA, blockId, floor],
    async () => {
      const res = await $api.get(`/v2/website/block-flat-data/${blockId}?floor=${floor}`);

      return res?.data?.data;
    },
    {
      enabled: !!blockId,
      onError: baseErrorHandler,
      refetchOnWindowFocus: false
    }
  );
}
